import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';
import { IconButton } from '@material-ui/core';
import { DEFAULT } from '../../../constants';

// Redux
import { connect } from 'react-redux';

// Icons
// import ViewIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';

// Components
import ListTable from '../../../components/ListTable';
import ConfirmationModal from '../../../components/ConfirmationModal';

// API
import { listRooms, deleteRoom } from '../../../api';

// Alerts
import { setSuccess, clearErrors, setAlert } from '../../../redux/actions/alertActions';

// Constants
const COLUMNS = (setupMode, onDelete) => [
  ...(setupMode ? [
    // {
    //   title: 'View',
    //   render: rowData => (
    //     <Link to={'/admin/rooms/' + rowData.getID()}><ViewIcon /></Link>
    //   ),
    //   width: null,
    //   cellStyle: {
    //     width: 25
    //   }
    // },
    {
      title: 'Delete',
      render: rowData => (
        <IconButton onClick={() => onDelete(rowData)}><DeleteIcon /></IconButton>
      ),
      width: null,
      cellStyle: {
        width: 25
      }
    }
  ] : []),
  {
    field: 'identifier',
    title: 'Identifier'
  },
  {
    field: 'floor.identifier',
    title: 'Floor'
  }
];

class Rooms extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDeleteRoom: null,
      isLoading: false
    };
  }

  componentWillUnmount() {
    this.props.clearErrors();
  }

  onDelete = (room) => {
    this.setState({ confirmDeleteRoom: room });
  }

  deleteRoom = () => {
    this.setState({ isLoading: true });
    deleteRoom(this.state.confirmDeleteRoom.getID()).then(() => {
      this.setState({ isLoading: false, confirmDeleteRoom: null });
      this.props.setSuccess('Room deleted successfully.');
      // Temp: Refresh page
      window.location.reload();
    }).catch(error => {
      this.setState({ isLoading: false });
      this.props.setError(error ?? 'Error: Unable to delete room.');
    });
  }

  render() {
    return (
      <>
        <ConfirmationModal
          open={this.state.confirmDeleteRoom != null}
          onClose={() => this.setState({ confirmDeleteRoom: null })}
          onConfirm={this.deleteRoom}
          color={this.props.statusColor}
          title={`Are you sure you want to delete room ${this.state.confirmDeleteRoom?.getIdentifier()}?`}
          body={'The room will no longer exist.'}
          isLoading={this.state.isLoading}
        />
        <ListTable
          title='Rooms'
          buttonLink='/admin/rooms/create'
          buttonText='Create New'
          columns={COLUMNS(this.props.setupMode, this.onDelete)}
          retrievalFunction={listRooms}
          hideButton={!this.props.setupMode}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  setupMode: state.setupMode.mode || state.setupMode.isLoading,
  statusColor: state.status.schoolStatus ? state.status.schoolStatus.getColor() : DEFAULT,
});

const mapDispatchToProps = dispatch => ({
  setError: (msg) => {
    dispatch(clearErrors());
    setAlert(dispatch, msg);
  },
  setSuccess: (msg) => setSuccess(dispatch, msg),
  clearErrors: () => dispatch(clearErrors())
});

Rooms.propTypes = {
  setupMode: PropTypes.bool.isRequired,
  setError: PropTypes.func.isRequired,
  setSuccess: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  statusColor: PropTypes.string.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Rooms);
